// console-disable.js

console.log(`process.env.NODE_ENV`,process.env.NODE_ENV)
if (process.env.NODE_ENV === 'production') {
    // Disable console.log in the production environment
    window.console.log = () => {};
    window.console.error = () => {}
    window.console.debug = () => {}
}
  